import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { sendOtpUser, loginUser } from "../redux/auth/authSlice";

const SignInLayer = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [reference, setReference] = useState("");
  const [timer, setTimer] = useState(120);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputsRef = useRef([]);
  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec < 10 ? "0" : ""}${sec}`;
  };
  useEffect(() => {
    let interval;

    if (step === 2 && isResendDisabled) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setIsResendDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [step, isResendDisabled]);

  const handleOtpChange = (e, index) => {

    let value = e.target.value;

    if (!/^\d*$/.test(value)) return;

    value = value.slice(-1);

    const updatedOtp = [...otp];
    updatedOtp[index] = value;

    setOtp(updatedOtp);

    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {

    if (e.key === "Backspace") {

      if (otp[index]) {

        const updatedOtp = [...otp];
        updatedOtp[index] = "";
        setOtp(updatedOtp);

      } else if (index > 0) {

        inputsRef.current[index - 1]?.focus();
      }
    }
  };

  const handlePaste = (e) => {

    const pasted = e.clipboardData.getData("text");

    if (!/^\d+$/.test(pasted)) return;

    const digits = pasted.slice(0, 6).split("");

    const newOtp = ["", "", "", "", "", ""];

    digits.forEach((digit, i) => {
      newOtp[i] = digit;
    });

    setOtp(newOtp);

    const focusIndex = digits.length >= 6 ? 5 : digits.length;

    inputsRef.current[focusIndex]?.focus();
  };

  const sendOtp = async (e) => {

    e.preventDefault();

    const res = await dispatch(sendOtpUser({ email }));

    if (res.payload.status) {

      toast.success(res.payload.message);

      setReference(res.payload.data);

      setStep(2);
      setTimer(120);
      setIsResendDisabled(true);

    } else {

      toast.error(res.payload.message);
    }
  };
  const handleResendOtp = async () => {

    const res = await dispatch(sendOtpUser({ email }));

    if (res.payload.status) {
      toast.success("OTP resent successfully");

      setReference(res.payload.data);

      setTimer(120);
      setIsResendDisabled(true);

      setOtp(["", "", "", "", "", ""]);
      inputsRef.current[0]?.focus();

    } else {
      toast.error(res.payload.message);
    }
  };

  const verifyOtp = async (e) => {

    e.preventDefault();

    const otpValue = otp.join("");

    if (otpValue.length !== 6) {

      toast.error("Please enter complete OTP");
      return;
    }

    const res = await dispatch(
      loginUser({
        email,
        otp: Number(otpValue),
        reference
      })
    );

    if (res.payload.status) {

      toast.success(res.payload.message || "Login Successful");

      localStorage.setItem("token", res.payload.data.token);
      localStorage.setItem("user", JSON.stringify(res.payload.data.user));
      const user = res.payload.data.user;
      if (user?.Role?.name === "SPONSOR") {
        navigate("/sponsors");
      } else {
        navigate("/dashboard");
      }

    } else {

      toast.error(res.payload.message);
    }
  };

  return (
    <section className='auth bg-base d-flex flex-wrap'>

      <div className='auth-left d-lg-block d-none'>
        <img
          src='assets/images/admin-banner.png'
          alt=''
          className='w-100 h-100 object-cover'
        />
      </div>

      <div className='auth-right py-32 px-24 d-flex flex-column justify-content-center'>

        <div className='max-w-464-px mx-auto w-100'>

          {step === 1 && (

            <form onSubmit={sendOtp}>

              <Link to='/' className='mb-40 max-w-290-px'>
                <img src='assets/images/logo.svg' alt='' />
              </Link>

              <h4 className='mb-12 text-primary'>
                Sign In to your Account
              </h4>

              <p className='mb-32 text-primary text-lg'>
                Please enter your email to continue.
              </p>

              <div className='icon-field mb-16'>

                <span className='icon top-50 translate-middle-y'>
                  <Icon icon='mage:email' />
                </span>

                <input
                  type='email'
                  className='form-control h-56-px bg-neutral-50 radius-12'
                  placeholder='Email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />

              </div>

              <button
                type='submit'
                className='btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32'
              >
                Send OTP
              </button>

            </form>

          )}

          {step === 2 && (

            <form onSubmit={verifyOtp}>

              <Link to='/' className='mb-40 max-w-290-px'>
                <img src='assets/images/logo.svg' alt='' />
              </Link>

              <h4 className='mb-12 text-primary'>
                Verify Identity
              </h4>

              <p className='mb-32 text-primary text-lg'>
                Enter the 6 digit OTP sent to your email address.
              </p>

              <div
                className="d-flex gap-12 mb-16 justify-content-center"
                onPaste={handlePaste}
              >

                {otp.map((digit, index) => (

                  <input
                    key={index}
                    ref={(el) => (inputsRef.current[index] = el)}
                    type="text"
                    inputMode="numeric"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    className="form-control text-center radius-12"
                    style={{
                      width: "56px",
                      height: "56px",
                      fontSize: "20px",
                      fontWeight: "600"
                    }}
                  />

                ))}

              </div>
              <div className="text-center mb-16">

                {isResendDisabled ? (
                  <p className="text-sm text-gray-500">
                    Resend OTP in <strong>{formatTime(timer)}</strong>
                  </p>
                ) : (
                  <button
                    type="button"
                    onClick={handleResendOtp}
                    className="btn btn-link p-0 text-primary"
                  >
                    Resend OTP
                  </button>
                )}

              </div>

              <button
                type='submit'
                className='btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32'
              >
                Verify Account
              </button>

            </form>

          )}

        </div>

      </div>

    </section>
  );
};

export default SignInLayer;